import { QueryClientProvider } from "@tanstack/react-query";
import type { i18n } from "i18next";
import type { AuthConfig } from "@fmc-digital/core-auth";
import { AuthProvider } from "@fmc-digital/core-auth";
import { I18nextProvider } from "@fmc-digital/i18n";
import { ThemeProvider } from "@fmc-digital/ui";

import { queryClient } from "./queryClient";

interface AppProvidersProps {
  authConfig: AuthConfig;
  i18nInstance: i18n;
  children: React.ReactNode;
}

export function AppProviders({
  authConfig,
  i18nInstance,
  children,
}: Readonly<AppProvidersProps>) {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18nInstance}>
        <ThemeProvider defaultMode="light">
          <AuthProvider config={authConfig}>{children}</AuthProvider>
        </ThemeProvider>
      </I18nextProvider>
    </QueryClientProvider>
  );
}
